import '../../utils/polyfills'

import React, { Fragment, PureComponent } from 'react'
import { ThemeProvider } from 'react-jss'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import * as theme from '../../theme'
import { AppWithStyle } from '..'
import Seo from '../Seo'
import DefaultHead from '../DefaultHead'

export default class App extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    seo: PropTypes.shape(Seo.propTypes).isRequired,
  }

  render() {
    const { children, seo } = this.props

    return (
      <Fragment>
        <Helmet />
        <ThemeProvider theme={theme}>
          <AppWithStyle>
            <DefaultHead />
            <Seo {...seo} />
            <Helmet />
            {children}
          </AppWithStyle>
        </ThemeProvider>
      </Fragment>
    )
  }
}
